import {
    isDesMobile
} from "@common/utils";

const state = {
    isDesMobile: isDesMobile(),
    passwordDialog: false
}

const mutations = {
    UPDATE_PASS_DIALOG: (state, val) => {
        state.passwordDialog = val
    }
}

const actions = {
    updatePasswordDialog({
        commit
    }, val) {
        commit('UPDATE_PASS_DIALOG', val)
    },
}

const getters = {
    isDesMobile: state => state.isDesMobile,
    passwordDialog: state => state.passwordDialog
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/match/store/mobile.js